import React from 'react'
import { Segmented } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import textSubmissionDrawerSelectors from '../../../../../store/selectors/text-submission-drawer.selectors'
import { textSubmissionDrawerActions, ViewModes } from '../../../../../store/slices/text-submission-drawer.slice'
import { FilePdfOutlined, FileDoneOutlined, FileExclamationOutlined } from '@ant-design/icons'
import submissionSelectors from '../../../../../store/selectors/submission.selectors'
import { useAutoViewMode } from '../../../../../store/apis/utils/hooks/text-submission.hooks'
import { errorColor } from '../../../../../constants/styles'

const ViewModeSelect = () => {
    const dispatch = useDispatch()
    const viewMode = useSelector(textSubmissionDrawerSelectors.viewMode)
    const submissionId = useSelector(submissionSelectors.openedSubmissionId)
    const isParsedModeDisabled = useAutoViewMode(submissionId)

    const onViewModeChange = mode => {
        dispatch(textSubmissionDrawerActions.setViewMode(mode))
    }

    return (
        <Segmented
            options={[
                { 
                    label: isParsedModeDisabled ? <FileExclamationOutlined style={{ color: errorColor }} /> : <FileDoneOutlined />, 
                    value: ViewModes.PARSED, 
                    title: isParsedModeDisabled ? 'Could not parse answers' : 'Parsed',
                    disabled: isParsedModeDisabled
                },
                { label: <FilePdfOutlined />, value: ViewModes.PDF, title: 'PDF' },
            ]}
            value={viewMode}
            onChange={onViewModeChange}
        />
    )
}

export default ViewModeSelect 